module.exports = __webpack_public_path__ + "static/media/9.ceed5761.jpg";